import type { Deck } from '@/framework/types';
import { slides } from './slides';
import './styles.css';

const deck: Deck = {
  slug: 'broker-side-filter-for-kafka',
  category: 'event-talks',
  title: 'Everything You Wanted from Broker-Side Filtering (and More): Solving KAFKA-6020',
  speaker: 'David Kjerrumgaard & Álvaro Rodríguez · StreamNative',
  description:
    'A 40-minute demo-led talk: a production-ready, open-source broker-side filter for Apache ' +
    'Kafka, validated at scale on financial-market-data and multi-topic logistics workloads, ' +
    'with a minimally-invasive SDK that drops into existing Kafka consumers — one jar, one line ' +
    'of code, no application rewrite.',
  // TODO: replace with the confirmed Berlin Buzzwords 2026 session date once published.
  date: '2026-06-09',
  context: 'Berlin Buzzwords 2026 · Berlin',
  visibility: 'public',
  slides,
};

export default deck;
